<!-- Modal -->
<mat-dialog-content>
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalScrollableTitle">End Subscription?</h5>
    <button (click)="noActionDIalog()" style="position: absolute; right: 15px; top:25px" type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p class="p_class" style="padding-top: 10px;">Please confirm that you want to unsubscribe from:</p>
    <ul class="p2 cancel-plan" *ngFor="let map of unSubMaps">
      <li>{{ map }}</li>
    </ul>
    <span id="seats-id">
      <ul class="p2"></ul>
    </span>
    <span id="annual-seats-id">
      <ul class="p2"></ul>
    </span>
    <span id="month-seats-id">
      <ul></ul>
    </span>
    <span id="six-months-seats-id">
      <ul></ul>
    </span>
    <p class="p_class">
      Access will continue through the end of your billing&nbsp;cycle.
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="gernal-btn" (click)="unSubscribe()">Yes</button>
  <button mat-button  cdkFocusInitial class="gernal-btn" (click)="noActionDIalog()">Cancel</button>
</mat-dialog-actions>
